
import UseDynamicClubReport from './UseDynamicClubReporting';

import ViewDynamicKendoReport from '@usas/ui-web/components/embeddedReports/ViewDynamicKendoReport';

const DynamicClubReport = () => {
  const { reportParameters } = UseDynamicClubReport();

  return (
    <div>
        <ViewDynamicKendoReport
          reportId={265}
          reportParameters={reportParameters}
        />
    </div>
  );
};


export default DynamicClubReport;


